"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Portfolio() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const heroImg = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const stackImgs = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const wideImg = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const wideCaption = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const stackedImages = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/web_design_mockup_1.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/web_design_mockup_1.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/web_design_mockup_1.png-wvc-sizes",
    alt: "Modernes Webdesign Mockup auf einem Laptop",
    coord: "53.1435° N / 8.2147° E"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/web_design_mockup_2.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/web_design_mockup_2.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/web_design_mockup_2.png-wvc-sizes",
    alt: "Responsive Webdesign Darstellung auf Tablet",
    coord: "53.1435° N / 8.2147° E"
  }];
  return <section data-section-id="4875" id="exzellenz-in-bildern" className="bg-background text-foreground py-32 md:py-48 px-6 md:px-12 lg:px-16 overflow-hidden">
      <div className="max-w-[1400px] mx-auto">
        {}
        <div ref={header.ref} className={`grid grid-cols-1 md:grid-cols-12 gap-8 mb-20 md:mb-28 transition-all duration-1000 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="md:col-span-7 lg:col-span-5">
            <p className="font-default text-xs uppercase tracking-[0.2em] mb-8" style={{
            color: "var(--primary)"
          }}>
              § 01 // PORTFOLIO
            </p>
            <h2 className="font-default font-light text-foreground text-5xl md:text-6xl lg:text-[80px] leading-[0.95] tracking-tight mb-8">
              Digitale <em className="italic font-normal">Meisterwerke</em>.
            </h2>
            <p className="text-muted-foreground text-base md:text-lg leading-relaxed max-w-md font-default">
              Wir gestalten digitale Erlebnisse, die Oldenburg und darüber hinaus begeistern. 
              Unsere Referenzen spiegeln Präzision, Ästhetik und technische Exzellenz wider. 
              <Link to="/ServicesPage" className="text-foreground underline underline-offset-4 hover:text-[var(--primary)] transition-colors mx-1">Unsere Services entdecken</Link> 
              oder direkt ein <Link to="/ContactPage" className="text-foreground underline underline-offset-4 hover:text-[var(--primary)] transition-colors">Projekt anfragen</Link>.
              Weitere Projekte werden in Kürze ergänzt.
            </p>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 mb-6 md:mb-8">
          {}
          <div ref={heroImg.ref} className={`md:col-span-8 group relative overflow-hidden transition-all duration-1000 ease-out ${heroImg.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="relative w-full h-[420px] md:h-[600px] lg:h-[720px] overflow-hidden">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/hero_portfolio_showcase.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/hero_portfolio_showcase.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/hero_portfolio_showcase.webp-wvc-sizes" alt="Premium Webdesign Showcase auf Desktop Monitor" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1000ms] ease-out group-hover:scale-105" style={{
              filter: "contrast(1.05) saturate(0.9)"
            }} />
              {}
              <div className="absolute inset-0 opacity-20 mix-blend-overlay pointer-events-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.5'/%3E%3C/svg%3E\")"
            }} />
              {}
              <div className="absolute inset-0 border border-transparent group-hover:border-[var(--primary)] transition-colors duration-700 pointer-events-none" aria-hidden="true" />
              {}
              <div className="absolute top-4 left-4 md:top-6 md:left-6">
                <span className="font-default text-[10px] md:text-xs uppercase tracking-[0.2em] px-2 py-1 bg-background/60 backdrop-blur-sm" style={{
                color: "var(--primary)"
              }}>
                  53.1435° N / 8.2147° E
                </span>
              </div>
            </div>
            <p className="font-default text-[10px] md:text-xs uppercase tracking-[0.2em] text-muted-foreground mt-4">
              Orvo Web / Premium Webdesign / Referenz-Projekt
            </p>
          </div>

          {}
          <div ref={stackImgs.ref} className={`md:col-span-4 flex flex-col gap-6 md:gap-8 transition-all duration-1000 delay-200 ease-out ${stackImgs.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {stackedImages.map((image, i) => <div data-index={i} key={i} className="group relative overflow-hidden">
                <div className="relative w-full h-[280px] md:h-[290px] lg:h-[350px] overflow-hidden">
                  <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1000ms] ease-out group-hover:scale-105" style={{
                filter: "contrast(1.05) saturate(0.9)"
              }} />
                  <div className="absolute inset-0 opacity-20 mix-blend-overlay pointer-events-none" style={{
                backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.5'/%3E%3C/svg%3E\")"
              }} />
                  <div className="absolute inset-0 border border-transparent group-hover:border-[var(--primary)] transition-colors duration-700 pointer-events-none" aria-hidden="true" />
                  <div className="absolute top-4 left-4">
                    <span className="font-default text-[10px] uppercase tracking-[0.2em] px-2 py-1 bg-background/60 backdrop-blur-sm" style={{
                  color: "var(--primary)"
                }}>
                      {image.coord}
                    </span>
                  </div>
                </div>
              </div>)}
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 mt-12 md:mt-20">
          {}
          <div ref={wideCaption.ref} className={`md:col-span-4 flex flex-col justify-end pb-4 transition-all duration-1000 ease-out ${wideCaption.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <p className="font-default text-xs uppercase tracking-[0.2em] mb-6" style={{
            color: "var(--primary)"
          }}>
              Zukunft / Ausblick / 2024
            </p>
            <p className="text-muted-foreground text-sm md:text-base leading-relaxed mb-8 max-w-sm font-default">
              Wir arbeiten kontinuierlich an neuen, spannenden Projekten für unsere Kunden. 
              Bald finden Sie hier weitere Einblicke in unsere Arbeit und unsere Design-Philosophie.
            </p>
            <div>
              <Button asChild variant="ghost" className="group h-auto p-0 hover:bg-transparent font-default text-xs uppercase tracking-[0.2em] text-foreground hover:text-[var(--primary)]">
                <Link to="/ContactPage">
                  <span>Jetzt Projekt anfragen</span>
                  <ArrowRight className="size-3.5 transition-transform duration-500 group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={wideImg.ref} className={`md:col-span-8 group relative overflow-hidden transition-all duration-1000 delay-200 ease-out ${wideImg.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="relative w-full h-[320px] md:h-[440px] lg:h-[520px] overflow-hidden">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/web_design_process_preview.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/web_design_process_preview.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1716638/img/web_design_process_preview.png-wvc-sizes" alt="Webdesign Prozess und Konzept Visualisierung" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1000ms] ease-out group-hover:scale-105" style={{
              filter: "contrast(1.05) saturate(0.9)"
            }} />
              <div className="absolute inset-0 opacity-20 mix-blend-overlay pointer-events-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.5'/%3E%3C/svg%3E\")"
            }} />
              <div className="absolute inset-0 border border-transparent group-hover:border-[var(--primary)] transition-colors duration-700 pointer-events-none" aria-hidden="true" />
              <div className="absolute top-4 left-4 md:top-6 md:left-6">
                <span className="font-default text-[10px] md:text-xs uppercase tracking-[0.2em] px-2 py-1 bg-background/60 backdrop-blur-sm" style={{
                color: "var(--primary)"
              }}>
                  53.1435° N / 8.2147° E
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}